import classNames from 'clsx';
import React from 'react';

import CreateClubButton from '../CreateClubButton/CreateClubButton';
import JoinClubButton from '../JoinClubButton/JoinClubButton';

import styles from './ClubButtons.scss';

export const ClubButtons = ({ className }: { className?: string }) => (
  <div className={classNames(styles.buttons, className)}>
    <JoinClubButton loading={false} />
    <CreateClubButton loading={false} />
  </div>
);

export default ClubButtons;
